import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { DataGrid } from "@mui/x-data-grid";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { validatePermission } from "../../../../utils/permissionUtils";
import { usePermissions } from "../../../../context/permissionContext";
import Loader from "../../../../components/Loader/Loader";
import "../../../../components/common/css/datatable.scss";

const CareerList = () => {
  const [query, setQuery] = useState("");
  const [data, setData] = useState([]);
  const [status, setStatus] = useState([]);
  const [loading, setLoading] = useState(false);
  const { permissions, permissionsMapping } = usePermissions();

  const search = (data) => {
    return data?.filter(
      (item) =>
        item?.title?.toLowerCase()?.includes(query) ||
        item?.email?.toLowerCase()?.includes(query) ||
        item?.datePosted?.toLowerCase()?.includes(query) ||
        item?.validThrough?.toLowerCase()?.includes(query)
    );
  };

  const hasEditPermission = validatePermission(
    "Jobs Management:Edit",
    permissions,
    permissionsMapping
  );
  const hasDeletePermission = validatePermission(
    "Jobs Management:Delete",
    permissions,
    permissionsMapping
  );

  const deleteFunction = (id) => {
    const token = localStorage.getItem("accessToken");
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        var config = {
          method: "post",
          url: process.env.REACT_APP_API + "admin/delete-jobdetails",
          headers: {
            "x-access-token": token,
          },
          data: {
            id: id,
          },
        };
        axios(config)
          .then(function (res) {
            if (res.status == 200) {
              Swal.fire("Deleted!", "Your file has been deleted.", "success");
              fetchcategorydata();
              setLoading(false);
            }
          })
          .catch(function (error) {
            setLoading(false);
            console.log(error);
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        setLoading(false);
        Swal.fire("Cancelled", "Your data is safe", "error");
      }
    });
  };

  const fetchcategorydata = () => {
    const token = localStorage.getItem("accessToken");
    setLoading(true);
    var config = {
      method: "get",
      url: process.env.REACT_APP_API + "get-listing-jobopeing",
      headers: {
        "x-access-token": token,
      },
    };

    axios(config)
      .then(function (response) {
        setData(response.data.data.rows);
        setStatus({ value: response?.data?.data?.rows?.status });
        setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: error.response.data.message,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };

  useEffect(() => {
    fetchcategorydata();
  }, []);

  useEffect(() => {}, [status]);

  const statusColumn = [
    {
      field: "status",
      headerName: "Status",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <span
              className={`status ${
                params.row.status == 1 ? "Approved" : "Pending "
              }`}
            >
              {params.row.status == 1 ? "Active" : "Inactive"}
            </span>
          </div>
        );
      },
    },
  ];

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <Link
              to={`/career/${params.row.id} `}
              style={{ textDecoration: "none" }}
            >
              <div className="viewButton">
                <RemoveRedEyeOutlinedIcon />
              </div>
            </Link>
            {hasEditPermission && (
              <Link
                to={`/career/edit/${params.row.id} `}
                style={{ textDecoration: "none" }}
              >
                <div className="edittButton">
                  <EditOutlinedIcon />
                </div>
              </Link>
            )}
            {hasDeletePermission && (
              <div
                className="deleteButton"
                onClick={() => deleteFunction(params.row.id)}
              >
                <DeleteOutlineIcon />
              </div>
            )}
          </div>
        );
      },
    },
  ];

  const userColumns = [
    { field: "id", headerName: "ID", width: 70 },
    {
      field: "title",
      headerName: "Job Title",
      width: 200,
    },
    {
      field: "employmentType",
      headerName: "Employment Type",
      width: 200,
    },

    {
      field: "datePosted",
      headerName: "Start Date",
      width: 200,
    },
    {
      field: "validThrough",
      headerName: "End Date",
      width: 200,
    },
  ];

  return (
    <div className="datatable">
      <Loader isLoading={loading} />
      <div className="datatableTitle">
        <div className="tablesearch">
          <input
            type="text"
            placeholder="Search..."
            onChange={(e) => setQuery(e.target.value)}
          />
          <SearchOutlinedIcon className="sarchicon" />
        </div>
        <h5 style={{ marginLeft: "-10%" }}>Job List</h5>
        {hasEditPermission && (
          <Link to="/career/add-job" className="link">
            Add New
          </Link>
        )}
      </div>
      <DataGrid
        className="datagrid"
        rows={search(data)}
        columns={userColumns.concat(statusColumn, actionColumn)}
        pageSize={9}
        rowsPerPageOptions={[9]}
      />
    </div>
  );
};

export default CareerList;
